// @ts-nocheck
import React, { useCallback, useState, useEffect } from 'react';
import { FormGroup, Intent } from '@blueprintjs/core';

import { MoneyInputGroup } from '@/components';
import { CellType } from '@/constants';

const PercentFieldCell = ({
  cell: { value: initialValue },
  row: { index },
  column: { id },
  payload: { errors, updateData },
}) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = useCallback((value) => {
    const num = parseFloat(value);
    if (num < 0) {
      setError('Discount cannot be negative.');
    } else if (num > 100) {
      setError('Discount cannot exceed 100%.');
    } else {
      setError(null);
    }
    setValue(value);
  }, [setValue]);

  const handleBlurChange = (newValue) => {
    const parsedValue = newValue === '' || newValue === undefined
      ? '' : parseInt(newValue, 10);
    const num = typeof parsedValue === 'number' ? parsedValue : 0;
    const clamped = Math.min(100, Math.max(0, num));
    setError(null);
    updateData(index, id, clamped);
  };

  const fieldError = error || errors?.[index]?.[id];

  return (
    <FormGroup
      intent={fieldError ? Intent.DANGER : null}
      helperText={fieldError ? <span style={{ color: '#cd4246', fontSize: 11 }}>{fieldError}</span> : null}
    >
      <MoneyInputGroup
        prefix={'%'}
        value={value}
        onChange={handleChange}
        onBlurValue={handleBlurChange}
      />
    </FormGroup>
  );
};

PercentFieldCell.cellType = CellType.Field;

export default PercentFieldCell;
